import {CalenderSchedule, Schedule, TimeFormat, WeekDay} from '../../../Types/types';

export const columns = [
	{
		id: 'name',
		title: 'Name',
		width: 250,
		priority: 1,
		isKey: true,
	},

	{
		id: 'allDevices',
		title: 'Devices',
		width: 200,
		priority: 3,
	},
];

export const backendScheduleToCalenderSchedule = (schedule: Schedule): CalenderSchedule => {
	const calenderSchedule: CalenderSchedule = {
		id: schedule.id,
		name: schedule.name,
		devices: schedule.devices.map((device) => {
			return device.friendlyName ? device.friendlyName : device.id;
		}),
		scheduleEvents: schedule.scheduleEvents.map((event) => {
			return {
				id: event.id,
				start: {
					day: dayConverter(event.days[0]),
					time: (event.startTime.split(':')[0] + ':' + event.startTime.split(':')[1]) as TimeFormat,
				},
				end: {
					day: dayConverter(event.days[event.days.length - 1]),
					time: (event.endTime.split(':')[0] + ':' + event.endTime.split(':')[1]) as TimeFormat,
				},
			};
		}),
		allDevices: '',
		temperatures: {on: 0, off: 0},
	};
	return calenderSchedule;
};

export const smallDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const bigDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export type SmallDays = (typeof smallDays)[number];
export type BigDays = (typeof bigDays)[number];

export type Days = SmallDays | BigDays;

const dayConverter = (day: Days): WeekDay => {
	const smallIndex = smallDays.indexOf(day);
	const bigIndex = bigDays.indexOf(day);
	if (smallIndex !== -1) {
		return bigDays[smallIndex] as WeekDay;
	} else if (bigIndex !== -1) {
		return smallDays[bigIndex] as WeekDay;
	} else {
		return day as WeekDay;
	}
};
